import { render, staticRenderFns } from "./ArapPersAcct.vue?vue&type=template&id=81a19314&scoped=true&"
import script from "./ArapPersAcct.vue?vue&type=script&lang=js&"
export * from "./ArapPersAcct.vue?vue&type=script&lang=js&"
import style0 from "./ArapPersAcct.vue?vue&type=style&index=0&id=81a19314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a19314",
  null
  
)

export default component.exports